module.exports = __webpack_public_path__ + "1f7b53506c68d35e1d331d4a29f89bb1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-2.png
// module id = 2147
// module chunks = 0